import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Card from 'react-bootstrap/Card';

export default class PDC extends Component {
  state = {
    content: 'Veuillez patienter',
  };

  componentDidMount() {
    fetch(`${origin}/pdc.md`)
      .then(response => response.text())
      .then(content => {
        this.setState({ content });
      });
  }

  render() {
    return (
      <div
        className={(this.props.home && 'homePadding') || undefined}
        style={{ marginTop: '1em' }}
      >
        <Card style={{ position: 'fixed', top: '8vh', bottom: '8vh', left: '50%', transform: 'translateX(-50%)', width: '90%', maxWidth: '1200px', overflowY: 'scroll' }}>
          <Card.Body >
            <ReactMarkdown>{this.state.content}</ReactMarkdown>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

PDC.propTypes = {
  home: PropTypes.bool,
};
